import React, { useState, useEffect } from 'react';
import { TrendingUp, Check } from 'lucide-react';

interface TaskProgressPanelProps {
  currentProgress?: number;
  onProgressSelect: (progress: number) => void;
  onClose?: () => void;
}

export const TaskProgressPanel: React.FC<TaskProgressPanelProps> = ({
  currentProgress = 0,
  onProgressSelect,
  onClose,
}) => {
  const [newProgress, setNewProgress] = useState(currentProgress);

  useEffect(() => {
    setNewProgress(currentProgress);
  }, [currentProgress]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // 親コンポーネントに選択結果を返す（保存は親側で行う）
    onProgressSelect(newProgress);
    if (onClose) {
      onClose();
    }
  };

  const progressOptions = [0, 25, 50, 75, 100];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      {/* ヘッダー */}
      <div className="p-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-blue-600 dark:text-blue-400" />
            <h3 className="font-semibold text-gray-900 dark:text-white">
              進捗度を選択
            </h3>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
            <span className="font-medium">現在: {currentProgress}%</span>
          </div>
        </div>
      </div>

      {/* 進捗度選択フォーム */}
      <div className="p-4">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-3">
              進捗度を選択してください
            </label>
            <div className="flex gap-2">
              {progressOptions.map((value) => (
                <button
                  key={value}
                  type="button"
                  onClick={() => setNewProgress(value)}
                  className={`flex-1 px-3 py-3 rounded-lg border-2 transition-all text-sm font-medium ${
                    newProgress === value
                      ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300'
                      : 'border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-gray-300 dark:hover:border-gray-600'
                  }`}
                >
                  {value}%
                </button>
              ))}
            </div>
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600
                text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700
                transition-colors font-medium text-sm"
            >
              キャンセル
            </button>
            <button
              type="submit"
              disabled={newProgress === currentProgress}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg
                hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed
                flex items-center justify-center gap-2 text-sm font-medium"
            >
              <Check className="w-4 h-4" />
              選択
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
